// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7ce74703","703":"94341aa6","787":"99e0aafc"}[chunkId] + ".chunk.js";
};